var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdt"},[_c('van-cell',{attrs:{"title":"姓名：","value":_vm.userInfo.fullName}}),_c('van-cell',{attrs:{"title":"性别：","value":_vm.userInfo.adminSex}}),_c('van-cell',{attrs:{"title":"联系电话：","value":_vm.userInfo.selfPhone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }